import React from "react";

const StatusIcon = ({
  d,
  transform,
  done,
  transformone,
  fillcolor,
  stroke,
  strokLinecap,
  strokeLinejoin,
  strokeWidth,
  width,
  height,
  viewBox,
  fillRule,
  customStyle,
  customClass,
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      className={customClass}
      style={customStyle}
    >
      <g
        stroke={stroke}
        strokeLinecap={strokLinecap}
        strokeLinejoin={strokeLinejoin}
        strokeWidth={strokeWidth}
        fill={fillcolor}
        fillRule={fillRule}
      >
        <path d={d} transform={transform} />
        <path d={done} transform={transformone} />
      </g>
    </svg>
  );
};

export default StatusIcon;
